import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component({})
export default class PopupLayout extends Vue {
    @Prop({type:String, default:''}) title!:string
    @Prop({type:String, default:''}) stClass!:string
    @Prop({type:String, default:'bg-gray'}) contentClass!:string
    @Prop({type:Boolean, default:false}) noHeader!:boolean
    @Prop({type:Boolean, default:false}) noFooter!:boolean
}
